(function () {
  const STORAGE_KEY = "aph_favorites_v1";

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent("aph:favorites:updated", { detail: { list } }));
  }

  function has(handle) {
    return read().includes(handle);
  }

  function toggle(handle) {
    const list = read();
    const idx = list.indexOf(handle);
    if (idx >= 0) list.splice(idx, 1);
    else list.unshift(handle);
    write(list);
    return list;
  }

  function setButtonsState(root = document) {
    const buttons = root.querySelectorAll("[data-aph-wishlist-btn][data-aph-handle]");
    buttons.forEach((btn) => {
      const handle = btn.getAttribute("data-aph-handle");
      if (!handle) return;
      const active = has(handle);
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function setCount() {
    const countEls = document.querySelectorAll("[data-aph-wishlist-count]");
    const count = read().length;

    countEls.forEach((el) => {
      if (count > 0) {
        el.textContent = String(count);
        el.style.display = "inline-flex";
      } else {
        el.textContent = "";
        el.style.display = "none";
      }
    });
  }

  function bindButtons() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-aph-wishlist-btn][data-aph-handle]");
      if (!btn) return;
      e.preventDefault();
      const handle = btn.getAttribute("data-aph-handle");
      if (!handle) return;
      toggle(handle);
      setButtonsState(document);
      setCount();
    });
  }

  function observeDom() {
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach((node) => {
            if (node && node.nodeType === 1) {
              setButtonsState(node);
            }
          });
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function getPdpHandle() {
    const el = document.querySelector("[data-aph-product-handle]");
    if (!el) return null;
    const h = el.getAttribute("data-aph-product-handle");
    return h ? String(h).trim() : null;
  }

  function buildWishlistButtonFromTemplate() {
    const tpl = document.getElementById("AphWishlistBtnTemplate");
    if (tpl && tpl.content && tpl.content.firstElementChild) {
      return tpl.content.firstElementChild.cloneNode(true);
    }

    const fallback = document.createElement("button");
    fallback.type = "button";
    fallback.className = "aph-wishlist-btn";
    fallback.setAttribute("data-aph-wishlist-btn", "");
    fallback.setAttribute("aria-label", "Add to favorites");
    fallback.setAttribute("aria-pressed", "false");
    fallback.textContent = "♡";
    return fallback;
  }

  function injectPdpBtn() {
    const wrap = document.querySelector(".section-main-product .quantity-input-wrapper");
    const handle = getPdpHandle();
    if (!wrap || !handle) return;

    if (wrap.querySelector(".aph-wishlist-btn--pdp")) {
      setButtonsState(wrap);
      return;
    }

    const btn = buildWishlistButtonFromTemplate();
    btn.classList.add("aph-wishlist-btn--pdp");
    btn.setAttribute("data-aph-handle", handle);

    wrap.classList.add("has-aph-wishlist");
    wrap.appendChild(btn);

    setButtonsState(wrap);
  }

  let resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(injectPdpBtn, 120);
  }

  window.APHWishlist = { read, write, has, toggle };

  document.addEventListener("DOMContentLoaded", () => {
    bindButtons();
    setButtonsState(document);
    setCount();
    observeDom();

    injectPdpBtn();
    window.addEventListener("resize", onResize);

    setTimeout(injectPdpBtn, 300);
    setTimeout(injectPdpBtn, 900);
  });

  document.addEventListener("aph:favorites:updated", () => {
    setButtonsState(document);
    setCount();
  });

  document.addEventListener("shopify:section:load", () => {
    injectPdpBtn();
  });
})();
